class HeapService {

    constructor() {}

    /**
     * Function to set data as a user property in Heap instance.
     * @param rrasData Rras data object
     */
    setData (rrasData){
        heap.identify(rrasData.id);
        heap.addUserProperties({
           Fund: rrasData.fund,
           Email: rrasData.email,
           Organization: rrasData.riversideOrgId || '',
           Role: rrasData.roles.toString()
        });
    }
}

export default new HeapService();
